export default function AffiliateDisclosurePage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-6">Affiliate Disclosure</h1>
          <p className="text-sm text-muted-foreground mb-8">Last Updated: January 2026</p>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-lg leading-relaxed">
              InsideHigherEducation is committed to transparency in all our business relationships. This page discloses our affiliate partnerships and how we may earn commissions from certain links and recommendations on our website.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">What Are Affiliate Links?</h2>
            <p className="leading-relaxed">
              Affiliate links are special tracking URLs that allow us to earn a commission when you click on them and make a purchase or sign up for a service. These commissions come at no additional cost to you and help us maintain and improve our free content.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Our Affiliate Partnerships</h2>
            <p className="leading-relaxed">
              We partner with universities, online course platforms, and educational service providers. When you enroll in courses, apply to universities, or purchase educational products through our affiliate links, we may receive a commission.
            </p>
            <p className="leading-relaxed">
              Our affiliate partners include, but are not limited to:
            </p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Online learning platforms (Coursera, Udemy, edX, etc.)</li>
              <li>Universities and educational institutions</li>
              <li>Study abroad consultancies</li>
              <li>Educational software and tools</li>
              <li>Test preparation services</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Sponsored Content</h2>
            <p className="leading-relaxed">
              Some articles and reviews on InsideHigherEducation may be sponsored or contain paid placements. We clearly label all sponsored content with a "Sponsored" badge to maintain transparency with our readers.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Our Editorial Independence</h2>
            <p className="leading-relaxed">
              While we earn commissions from some of our recommendations, our primary goal is to provide valuable, honest, and unbiased information to help you make informed educational decisions. We only recommend products, services, and institutions that we believe offer genuine value to our audience.
            </p>
            <p className="leading-relaxed">
              Our editorial team maintains full independence in creating content. Affiliate partnerships do not influence our educational analysis, university rankings, or article topics.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Your Support Matters</h2>
            <p className="leading-relaxed">
              By using our affiliate links, you help support InsideHigherEducation at no extra cost to you. This enables us to continue providing free, high-quality educational content, maintain our website, and expand our coverage of educational opportunities worldwide.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">Questions?</h2>
            <p className="leading-relaxed">
              If you have any questions about our affiliate relationships or disclosure policy, please contact us at:<br />
              <strong>Email:</strong> <a href="mailto:contact@insidehighereducation.eu" className="text-accent hover:underline">contact@insidehighereducation.eu</a>
            </p>

            <div className="bg-secondary rounded-sm p-6 mt-8">
              <p className="text-sm">
                <strong>Federal Trade Commission (FTC) Compliance:</strong> This disclosure is in accordance with the Federal Trade Commission's 16 CFR, Part 255: "Guides Concerning the Use of Endorsements and Testimonials in Advertising."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}